import React from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';

export const Shoes: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <Table>
      <Head className={Typography.CAPTION_12_SEMIBOLD}>
        <Col>
          한국
          <small className={Typography.CAPTION_10_REGULAR}>(mm)</small>
        </Col>
        <Col>
          일본
          <small className={Typography.CAPTION_10_REGULAR}>(cm)</small>
        </Col>
        <Col>미국</Col>
      </Head>
      <Row className={Typography.CAPTION_11_REGULAR}>
        <Col>220</Col>
        <Col>22</Col>
        <Col>5</Col>
      </Row>
      <Row className={Typography.CAPTION_11_REGULAR}>
        <Col>225</Col>
        <Col>22.5</Col>
        <Col>5.5</Col>
      </Row>
      <Row className={Typography.CAPTION_11_REGULAR}>
        <Col>230</Col>
        <Col>23</Col>
        <Col>6</Col>
      </Row>
      <Row className={Typography.CAPTION_11_REGULAR}>
        <Col>235</Col>
        <Col>23.5</Col>
        <Col>6.6</Col>
      </Row>
      <Row className={Typography.CAPTION_11_REGULAR}>
        <Col>240</Col>
        <Col>24</Col>
        <Col>7</Col>
      </Row>
      <Row className={Typography.CAPTION_11_REGULAR}>
        <Col>245</Col>
        <Col>24.5</Col>
        <Col>7.5</Col>
      </Row>
      <Row className={Typography.CAPTION_11_REGULAR}>
        <Col>250</Col>
        <Col>25</Col>
        <Col>8</Col>
      </Row>
      <Row className={Typography.CAPTION_11_REGULAR}>
        <Col>255</Col>
        <Col>25.5</Col>
        <Col>8.5</Col>
      </Row>
      <Row className={Typography.CAPTION_11_REGULAR}>
        <Col>260</Col>
        <Col>26</Col>
        <Col>9</Col>
      </Row>
      <Row className={Typography.CAPTION_11_REGULAR}>
        <Col>265</Col>
        <Col>26.5</Col>
        <Col>9.5</Col>
      </Row>
      <Row className={Typography.CAPTION_11_REGULAR}>
        <Col>270</Col>
        <Col>27</Col>
        <Col>10</Col>
      </Row>
    </Table>
  );
};

const Table = styled.div`
  width: 100%;
  margin-bottom: 32px;
  text-align: center;
  border-collapse: collapse;
`;

const Head = styled.div`
  display: flex;
  align-items: center;
  background-color: ${vars.v3Color.gray100};
`;

const Col = styled.div`
  height: 37px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 0;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  color: ${vars.v3Color.gray700};
  border-bottom: 1px solid ${vars.v3Color.gray100};

  &:last-of-type {
    border-color: ${vars.v3Color.gray150};
  }
`;
